export default "__VITE_ASSET__493523e8__"